module.exports = __webpack_public_path__ + "static/media/community.26fcbb63.svg";